// import 'babel-polyfill'
import 'es6-promise/auto'
import "@babel/polyfill"

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import VueLazyLoad from 'vue-lazyload'

import storage from './utils/storage.js'
import * as Api from './config/http.js';
import VueI18n from 'vue-i18n'
// import BaiduMap from 'vue-baidu-map'
import VueYoutube from 'vue-youtube'

import VueAliplayerV2 from 'vue-aliplayer-v2'

import VideoPlayer from 'vue-video-player'

import 'videojs-contrib-hls'

import * as echarts from 'echarts'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use(VueImageSwipe)

Vue.use(VideoPlayer)
Vue.use(VueYoutube)
Vue.use(VueAliplayerV2);
Vue.use(VueI18n)
Vue.use(VueLazyLoad, {
  error: require('./assets/images/loading.png'),
  loading: require('./assets/images/loading.png')
})

// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: '3umyuEDzQz9qbQzLh0zqW2RO7WbLncIe'
// })

let currentlange = 'zh'
localStorage.setItem('lange', currentlange)
const i18n = new VueI18n({ 
   locale: localStorage.getItem('lange') || currentlange, // 定义默认语言为中文 
   messages: {   
      'en': require('@/assets/languages/en.json'),
      'zh': require('@/assets/languages/zh.json'),  
    }
});
  

var message = (text, type = 'success') => {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: type,
    duration: 1000
  })
}
Vue.prototype.$msg = message;
Vue.config.productionTip = false
Vue.prototype.$api = Api;
Vue.prototype.$storage = storage;
Vue.prototype.$echarts = echarts

router.beforeEach((to, from, next) => {

  if(window.location.href.indexOf('web/#') > -1) {
    window.location.href = window.location.href.replace('web/#', 'web')
    return
  }
  
	// 帮助中心返回删除分页信息
	if(from.name == 'helpdetail' && to.name != 'help') {
		storage.remove('helpdetail')
		storage.remove('helpindexpage')
	}
  
  if(to.params.invite || to.query.invite) {
    window.localStorage.setItem('invite', to.params.invite || to.query.invite)
  }
  if (to.meta.title) {
    if (store.state.config.shop_name) {
      document.title = '三利达弓箭行业电商平台-' +  i18n.t(to.meta.l18ntitle) 
    } else {
      document.title = '三利达弓箭行业电商平台-' + i18n.t(to.meta.l18ntitle)
    }
  }
  next()
})

if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<=9){
  console.log('请升级浏览器')
}else{
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

